import { render, staticRenderFns } from "./PurchaseOrderFormEdit.vue?vue&type=template&id=0d68b1c0&scoped=true"
import script from "./PurchaseOrderFormEdit.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderFormEdit.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderFormEdit.vue?vue&type=style&index=0&id=0d68b1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d68b1c0",
  null
  
)

export default component.exports